import { render } from "./BokkerijenGame.vue?vue&type=template&id=e3ac8b44&scoped=true"
import script from "./BokkerijenGame.vue?vue&type=script&lang=js"
export * from "./BokkerijenGame.vue?vue&type=script&lang=js"

import "./BokkerijenGame.vue?vue&type=style&index=0&id=e3ac8b44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3ac8b44"]])

export default __exports__